import {
  getIsNetwork,
  getIsWhiteLabel,
  getLocalstorage,
  isAdvertiser,
  isPublisher
} from '~/helpers'
import localstorageConstants from '~/helpers/localstorage-manipulation'
import * as allRoutes from '~/routes'

type RoutesKey =
  | AccountTypes
  | 'common'
  | 'commonWhiteLabel'
  | 'groceryWhiteLabel'
  | 'industryWhiteLabel'

export const filterRoutes = ({
  modules,
  accountType = 'grocery',
  filterRoute
}: {
  modules: AccessModulesResponse[]
  accountType: AccountTypes | 'common'
  filterRoute?: (route: RootMenuItem) => boolean
}) => {
  const isWhiteLabel = getIsWhiteLabel()
  const isNetwork = getIsNetwork()

  const routesKey: RoutesKey = isWhiteLabel
    ? `${accountType}WhiteLabel`
    : accountType

  const privateRoutes = allRoutes[routesKey]

  const flattenModules: string[] =
    modules?.length &&
    modules.reduce((acc, item) => {
      const childrenIds = item.submodules.map(child => child.access_module_id)

      return [...acc, item.access_module_id, ...childrenIds]
    }, [])

  const cleanRoutes = privateRoutes
    .map(item => {
      const show =
        (filterRoute?.(item) ?? true) &&
        (!item?.id || flattenModules?.indexOf(item.id) > -1) &&
        (!item?.onlySuperAdmin
          ? true
          : getLocalstorage(localstorageConstants.SUPER_ADMIN) === 'true')

      const hasChildren = !!item?.children?.length

      const filterByModules = (child: ChildMenuItem) =>
        !child?.id || flattenModules?.indexOf(child.id) > -1

      const filterByWhiteLabel = (child: ChildMenuItem) =>
        isWhiteLabel ? !child?.onlyNewtail : true

      const filterByNetwork = (child: ChildMenuItem) =>
        child?.onlyNetwork ? isNetwork : true

      const filterByPublisher = (child: ChildMenuItem) =>
        isPublisher() ? !child?.onlyAdvertiser : true

      const filterByAdvertiser = (child: ChildMenuItem) =>
        isAdvertiser() ? !child?.onlyPublisher : true

      const filterBySuperAdmin = (child: ChildMenuItem) =>
        !child?.onlySuperAdmin
          ? true
          : getLocalstorage(localstorageConstants.SUPER_ADMIN) === 'true'

      const filterChildren = (child: ChildMenuItem) =>
        filterByModules(child) &&
        filterByWhiteLabel(child) &&
        filterByNetwork(child) &&
        filterByPublisher(child) &&
        filterByAdvertiser(child) &&
        filterBySuperAdmin(child)

      const children = hasChildren ? item.children.filter(filterChildren) : null

      return show ? { ...item, children } : null
    })
    .filter(item => !!item)

  return cleanRoutes
}
